// Release the old capture before opening the other lens: iOS may allow only one.
export async function switchCameraTrack({ media, senders, isCurrent, previousFacing = "user", capture = (constraints) => navigator.mediaDevices.getUserMedia(constraints) }) {
  const previous = media?.getVideoTracks?.()[0];
  if (!previous || !senders.length) throw new Error("Camera is not ready yet");
  const settings = previous.getSettings?.() || {};
  const oldFacing = settings.facingMode || previousFacing;
  const facing = oldFacing === "environment" ? "user" : "environment";
  const size = {};
  for (const key of ["width", "height", "frameRate"]) {
    if (settings[key]) size[key] = { ideal: settings[key] };
  }
  const install = async (video) => {
    const acquired = await capture({ audio: false, video: { ...size, ...video } });
    try {
      if (!isCurrent()) throw new Error("Camera switch cancelled");
      const track = acquired.getVideoTracks()[0];
      if (!track) throw new Error("No camera track available");
      // Wait for every sender before rollback, including partial failures in P2P rooms.
      const results = await Promise.allSettled(senders.map((sender) => sender.replaceTrack(track)));
      const failed = results.find((r) => r.status === "rejected");
      if (failed) throw failed.reason;
      if (!isCurrent()) throw new Error("Camera switch cancelled");
      media.getVideoTracks().forEach((old) => media.removeTrack(old));
      media.addTrack(track);
    } catch (error) {
      acquired.getTracks().forEach((track) => track.stop());
      throw error;
    }
  };
  previous.onended = null;
  previous.stop();
  try {
    await install({ facingMode: { exact: facing } });
    return facing;
  } catch (error) {
    if (!isCurrent()) throw error;
    try {
      await install(settings.deviceId
        ? { deviceId: { exact: settings.deviceId } }
        : { facingMode: { ideal: oldFacing } });
    } catch {
      throw new Error("Camera switch failed. Turn CAM off and on to try again.");
    }
    throw new Error("Could not switch camera; the original camera has been restored.");
  }
}
